const FALL_GRACE_BLOCKS = 3;
const FALL_DAMAGE_PER_BLOCK = 2;
const MAX_FALL_DAMAGE = 20;

export function computeFallDamage(fallDistance: number, inWater = false): number {
  if (inWater) return 0;
  const excess = fallDistance - FALL_GRACE_BLOCKS;
  if (excess <= 0) return 0;
  return Math.min(excess * FALL_DAMAGE_PER_BLOCK, MAX_FALL_DAMAGE);
}
